import { connect } from 'react-redux';
import { DashboardPageComponent } from './Dashboard.component';
import { getOperationalData } from 'shared/store/selectors/workspace.selector';
import { useReviewItems } from 'shared/hooks/knowledge-items.hooks';
import { useSelector } from 'react-redux';
import { fetchAvailableOrganizations } from 'shared/store/actions/available-organizations.actions';
import { isAccountAdmin, isCollaborator } from 'shared/store/selectors/auth.selector';
import { getUserId } from 'shared/store/selectors/user.selector';

const mapStateToProps = ({ auth, application, lang, workspace, organization }) => {
  const operationalData = getOperationalData({ workspace, organization });

  return {
    lang: lang.DASHBOARD,
    addAccLang: lang.ADD_ACCOUNT,
    sidebarLang: lang.SIDEBAR,
    adminMode: application.adminMode,
    calendarUrl: operationalData?.calendarUrl,
    scheduleUrlMap: operationalData?.scheduleUrls,
    isAdmin: isAccountAdmin({ auth }),
    quickLinks: operationalData?.quickLinks,
  };
};

const ConnectedDashboardPage = connect(mapStateToProps, { fetchAvailableOrganizations })(
  DashboardPageComponent,
);

/**
 * The home page. The items up for review come from the review endpoint: all owners for
 * an account admin, the user's own for a collaborator, nothing for a viewer.
 *
 * @returns {JSX.Element}
 * @example
 * <DashboardPage />
 */
export const DashboardPage = () => {
  const isAdmin = useSelector(isAccountAdmin);
  const canEdit = useSelector(isCollaborator);
  const userId = useSelector(getUserId);
  const {
    data: review,
    isPending,
    isError,
  } = useReviewItems(isAdmin ? [] : [userId], {
    enabled: canEdit && (isAdmin || !!userId),
  });

  return (
    <ConnectedDashboardPage
      expiredItems={review?.groups ?? {}}
      reviewableCount={review?.reviewableCount ?? 0}
      isCatalogLoaded={!canEdit || !isPending}
      reviewError={isError}
    />
  );
};
